import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// هندلر خودکار خطای بارگذاری chunk: پس از deploy نسخه جدید، اگر کاربری که
// سایت را باز داشته به مسیری برود که chunk قدیمی‌اش دیگر وجود ندارد،
// یک‌بار صفحه reload می‌شود تا نسخه جدید بی‌صدا بارگذاری شود
window.addEventListener('unhandledrejection', (event) => {
  const err = event.reason;
  const isChunkError =
    err?.name === 'ChunkLoadError' ||
    err?.message?.includes('Loading chunk') ||
    err?.message?.includes('Failed to fetch dynamically imported module') ||
    err?.message?.includes('error loading dynamically imported module');
  if (isChunkError) {
    const key = 'chunk-reload-attempt';
    // جلوگیری از حلقه بی‌نهایت: هر ۳۰ ثانیه حداکثر یک بار
    const last = Number(sessionStorage.getItem(key) || 0);
    if (Date.now() - last > 30000) {
      sessionStorage.setItem(key, String(Date.now()));
      window.location.reload();
    }
  }
});

// پاک‌سازی Service Workerهای قدیمی — بیلد فعلی SW ثبت نمی‌کند؛ اگر SW قدیمی
// (از نسخه‌های قبل) هنوز فعال باشد، index.html را از کش می‌دهد و پس از هر deploy
// کاربر ChunkLoadError و صفحه سفید می‌بیند
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((registrations) => registrations.forEach((r) => r.unregister()))
    .catch(() => {});
}
if ('caches' in window) {
  caches.keys()
    .then((keys) => keys.forEach((k) => caches.delete(k)))
    .catch(() => {});
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Service Worker disabled to prevent API request interception
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/sw.js')
//       .then((registration) => {
//         console.log('SW registered: ', registration);
//       })
//       .catch((registrationError) => {
//         console.log('SW registration failed: ', registrationError);
//       });
//   });
// }
